import React from "react";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
import shouldLoadDyna from "@gc-npm/core.utils.should-load-dyna";
import ErrorBoundary from "@/home_components/error-boundary";
import { wrapper } from "store";
import "@/styles/globals.scss";
import "@/styles/grid.scss";
import "@/styles/colors.scss";
import "@/styles/fonts.scss";
import "@/styles/skeleton.scss";
// IMPORTS
/* [STYLES] begins */
/* [STYLES] ends */
import "@/styles/card.scss";

const RouteHandler = dynamic(() => import("@gc-npm/core.route-handler"), {
  ssr: false,
});
const Saam = dynamic(() => import("@gc-npm/core.scripts.saam"), {
  ssr: false,
});
const OneTrust = dynamic(() => import("@gc-npm/components.one-trust-x"), {
  ssr: false,
});
const Dyna = dynamic(() => import("@gc-npm/core.scripts.dyna"), {
  ssr: false,
});

const App = ({ Component, pageProps }) => {
  const Modal = useSelector((state) => state.modals.Modal);
  return (
    <>   
      <RouteHandler />
      <ErrorBoundary>
        <Component {...pageProps} />
        {Modal && Modal}
        <OneTrust />
      </ErrorBoundary>
      <Saam />
      {shouldLoadDyna() && <Dyna />}
      {/* APP DELIMITER */}
    </>
  );
};

export default wrapper.withRedux(App);
